import { Portal } from '../../../pages'
import type {RouteObject} from 'react-router-dom'

export const portalRoutesData: RouteObject[] = [
    {
      id: '1',
      path: "portal",
      element: <Portal />
    },
  ];

